// Last working sha for bugs: f93d80dff33e7ddcbcf51b73726bac32826e76d3
import React, { useState, useEffect, useCallback } from 'react';
import {
  Card,
  CardHeader,
  Box,
  Typography,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  Divider,
  useMediaQuery,
  Checkbox,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import styled from 'styled-components';
import { GroupWork, InfoOutlined, Check } from '@material-ui/icons';
import { orange } from '@material-ui/core/colors';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import 'moment-timezone';
import TimeAgo from 'react-timeago';
import cloneDeep from 'lodash/cloneDeep';
import store from '../../../redux/store';
import TableLoader from '../../../components/TableLoader';
import * as pricingActionsImport from '../../../redux/actions/pricing';
import * as globalActionsImport from '../../../redux/actions/globals';
import { fetchSBEventMeta } from '../../../services/killshot';
import { setNotification, execute403Handler } from '../../../redux/actions/errorHandler';
import IntervalTooltip from '../../../components/IntervalTooltip';
import GroupElement from './GroupElement';
import {
  updateGroupsPosition,
  getBadGroupsData,
  updateGroupsPositionFromBE,
  setSectionsGroup,
  getGroupMarkets,
  getGroupsPosition,
  saveGroupChanges,
  validateGroupChanges,
} from '../../../helpers/pricing';
import { putEventGroupsSortingCriteria, putGroupsPosition } from '../../../helpers/api';
import { formatFloat, onlyNumbers } from '../../../shared/utils/helpers';
import { MARKETPLACE_ITEMS } from '../../../helpers/constants';
import { isStringEmpty } from '../../../shared/utils/validations';
import GroupCriteria from './GroupCriteria';
import GroupCriteriaHeader from './GroupCriteriaHeader';
import { useQueryAutopricerIntervals } from '../../../hooks';
import { setGroupsAction, updateGroupFields, setPushEnableAction } from '../../../redux/actions/refresh-groups';
import { setBadGroups } from '../../../redux/actions/groups';
import AntSwitch from '../../../components/Common/Switch/AntSwitch';
import { hasMarketplaceUniquePriceAccess } from '../../../helpers/user';

const styles = makeStyles(theme => ({
  pricingSection: {
    marginTop: '8px',
    flexGrow: 1,
    flexBasis: 'auto',
  },
  groupCardList: {
    listStyle: 'none',
    paddingLeft: '0',
  },
  groupCardContent: {
    overflowY: 'scroll',
    paddingTop: '0px',
    marginTop: '5px',
    height: '69vh',
    '@media(min-height: 1005px)': {
      height: '71.2vh',
    },
    '@media(min-height: 1075px)': {
      height: '75vh',
    },
    '@media(min-height: 1210px)': {
      height: '77.5vh',
    },
    '@media(min-height: 1290px)': {
      height: '79vh',
    },
    '@media(min-height: 1456px)': {
      height: '81vh',
    },
    '@media(min-height: 1940px)': {
      height: '85vh',
    },
  },
  priceAllBtn: {
    position: 'absolute',
    right: 0,
    margin: '10px 20px 0 0',
  },
  saveAllBtn: {
    marginLeft: '15px',
    paddingRight: '30px',
    paddingTop: '10px',
    marginBottom: '-8px',
  },
  paper: {
    position: 'absolute',
    width: theme.spacing(50),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    outline: 'none',
  },
  buttonProgress: {
    // color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  button: {
    marginTop: '10px',
  },
  buttonM: {
    position: 'relative',
  },
  avatar: {
    padding: '5px',
    height: '40px',
  },
  cardHeader: {
    height: '65px',
    backgroundColor: '#F4F4F4',
    '& .MuiCardHeader-avatar': {
      marginLeft: '13px',
    },
  },
  cardHeaderDark: {
    height: '65px',
    backgroundColor: '#2D3436',
    '& .MuiCardHeader-avatar': {
      marginLeft: '13px',
    },
  },
  h1: {
    alignItems: 'center',
  },
  // listings
  root: {
    padding: 8,
  },
  paperSectionGeneric: {
    marginTop: '8px',
  },
  paperSectionFullHeight: {
    // height: '100%',
  },
  paperSectionHalfHeight: {
    // height: '50%',
  },
  pricingFlexContainer: {
    display: 'flex',
    alignItems: 'stretch',
    alignContent: 'stretch',
    // height: '85vh',
  },
  pricingLoadingModalPaper: {
    position: 'absolute',
    width: theme.spacing(50),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
  },
  pricingLoadingModalContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cardContentRoot: {
    padding: '0 10px 10px 10px',
  },
  venueMapImg: {
    maxWidth: '100%',
    display: 'block',
  },
  metaList: {
    padding: '10px 0',
  },
  createGroupButtonWrap: {
    marginTop: theme.spacing(2),
  },
  createGroupModalHeaderText: {
    '& span': {
      marginRight: '10px',
    },
  },
  groupActions: {},
  pricingColumnFlexContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    alignContent: 'stretch',
  },
  addButton: {
    position: 'absolute',
    zIndex: '1',
    right: '10px',
    bottom: '44px',
  },
  labelDark: {
    color: '#BEBEBE',
  },
  label: {
    color: '#3C3C3C',
  },
  savedLabel: {
    fontSize: '14px',
    color: '#4CA353',
  },
  sortingSaved: {
    fontSize: '14px',
    lineHeight: '18.62px',
    fontWeight: 600,
    color: '#4CA353',
  },
  customBadge: {
    backgroundColor: orange[500],
    height: 12,
    width: 12,
    borderRadius: 10,
  },
  groupsLogo: {
    color: '#7D1F8D',
    fontSize: 30,
    marginLeft: '-3px',
    marginTop: '-2px',
  },
  groupsLogoBackground: {
    background: 'white',
    height: '25px',
    width: '25px',
    borderRadius: '100%',
  },
}));

const TitleEmptyContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const initialState = {
  isPushEventModalOpen: false,
  isPriceAllLoading: false,
  isGroupSaveLoading: false,
};

function Groups(props) {
  const classes = styles();
  const [state, setState] = useState(initialState);

  const theme = useTheme();

  const [sortingCriteriaClicked, setSortingCriteriaClicked] = useState(false);
  const [displaySortingsaved, setDisplaySortingsaved] = useState(false);
  const [displayCustomSortingOption, setDisplayCustomSortingOption] = useState(false);
  const [showPushMessage, setShowPushMessage] = useState(false);
  const [MetaSBEvent, setSBEventMeta] = useState(null);
  const { data: intervals, isFetching } = useQueryAutopricerIntervals();
  const SortingCriteriaList = ['default', 'averagecost', 'custom', 'numberoftickets', 'anchorprice'];
  const fetchData = async skyboxId => {
    const { pricingGroups, setGroupSortingCriteria } = props;

    const response = await fetchSBEventMeta(skyboxId);
    if (response && response.response) {
      setSBEventMeta(response.response);
      if (response.response.sorting_criteria && SortingCriteriaList.includes(response.response.sorting_criteria)) {
        setGroupSortingCriteria(response.response.sorting_criteria.toLowerCase());
        if (
          pricingGroups &&
          response.response.position &&
          Object.keys(response.response.position).length > 1 &&
          Object.keys(response.response.position).length === Object.keys(pricingGroups).length
        ) {
          updateGroupsPositionFromBE(pricingGroups, response.response.position);
        }
      } else {
        setGroupSortingCriteria('default');
      }
    } else {
      setSBEventMeta(null);
      setGroupSortingCriteria('default');
    }
  };

  const { badGroups, globalActions } = props;

  const [groupsPositionObj, setGroupsPositionObj] = useState({});
  const [isDragging, setIsDragging] = useState(0);

  const saveAllSubmit = async (justSave = false) => {
    const { handleGroupEditSubmit, pricingGroups, pricingActions, dispatch, setSaving } = props;

    const badGroupsData = getBadGroupsData(pricingGroups);
    if (badGroupsData && badGroupsData.length > 0) {
      const notification = {
        error: 'Changes to highlighted group(s) could not be saved. Please click on a group to see the specific error.',
      };

      dispatch(execute403Handler(notification.error));
      store.dispatch(setBadGroups(badGroupsData));
    } else {
      setSaving(true);
      store.dispatch(setBadGroups([]));
      if (justSave === false) {
        setState({ ...state, isPriceAllLoading: true });
      } else {
        setState({ ...state, isGroupSaveLoading: true });
      }
      pricingActions.setIsGroupContainerLoading(true);

      pricingActions.setIsGroupContainerLoading(true);
      await handleGroupEditSubmit(pricingGroups, justSave)();
      pricingActions.setIsGroupContainerLoading(false);
      setState({ ...state, isPriceAllLoading: false });
      setState({ ...state, isGroupSaveLoading: false });

      if (justSave === false) {
        const notification = {
          message:
            'Group prices are being pushed! Please allow up to 3 minutes for your price changes to be reflected.',
          variant: 'info',
        };

        dispatch(setNotification(notification.message));
        setState({
          ...state,
          isPushEventModalOpen: false,
        });
      }

      pricingActions.setIsGroupContainerLoading(false);
      const { skyboxId } = props;
      if (justSave === false) {
        setShowPushMessage(true);
      }
      fetchData(skyboxId);
      setSaving(false);
      setTimeout(() => {
        setShowPushMessage(false);
      }, 3000);
    }
  };

  const {
    focusedPricingGroup,
    groupedListings,
    SBEventMeta,
    pricingActions,
    filteredStubhubListings,
    currTNCompSections,
    typeListing,
    errorFlags,
    currPricingGroups,
    marketplaces,
    settings,
    handleGroupEditSubmit,
    getAnchorListingPrice,
    // eslint-disable-next-line react/prop-types
    groupsUpdateReArrange,
    focusPricingGroupSection,
    handleMarketplaceChange,
    saveZoneFilters,
    pricingGroups,
    isAbTest,
    isGroupContainerLoading,
    isLoading,
    isPricingLoading,
    isSaving,
    tags,
    groupCriteria,
    handleGroupCriteriaChanges,
    isCompAllGroup,
    handleGroupMarketplaceSelection,
    skyboxId,
    setErrorFlags,
    setUpdateListingsOnSave,
    validateChanges,
    groupSortingCriteria,
    setGroupSortingCriteria,
    loadingGroupedListings,
    setFocusGroupInfo,
    initialMarketPlaces,
    showTMRListPrice,
    showMPListPrice,
    showSHListPrice,
    showVSListPrice,
    allGroups,
  } = props;

  const { isPriceAllLoading, isGroupSaveLoading } = state;
  const isPriceAllDisabled = isLoading || isPricingLoading || currPricingGroups?.length < 1 || isPriceAllLoading;
  const [selectedPricingGroup, setSelectedPricingGroup] = useState(null);
  const [isTMRUniquePricingEvent, setIsTMRUniquePricingEvent] = useState(false);
  const [isSHUniquePricingEvent, setIsSHUniquePricingEvent] = useState(false);
  const [isVSUniquePricingEvent, setIsVSUniquePricingEvent] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const pageMD = useMediaQuery(theme.breakpoints.only('md'));

  useEffect(() => {
    const tmrUniquePricingGroups =
      allGroups.filter(
        g =>
          g?.unique_pricing !== null &&
          g?.unique_pricing?.TicketsNow?.markupdown_value !== 0 &&
          g?.unique_pricing?.TicketsNow?.markupdown_value > 0
      ).length > 0;
    setIsTMRUniquePricingEvent(tmrUniquePricingGroups);
    const shUniquePricingGroups =
      allGroups.filter(
        g =>
          g?.unique_pricing !== null &&
          g?.unique_pricing?.StubHub?.markupdown_value !== 0 &&
          g?.unique_pricing?.StubHub?.markupdown_value > 0
      ).length > 0;
    setIsSHUniquePricingEvent(shUniquePricingGroups);
    const vsUniquePricingGroups =
      allGroups.filter(
        g =>
          g?.unique_pricing !== null &&
          g?.unique_pricing?.Vivid?.markupdown_value !== 0 &&
          g?.unique_pricing?.Vivid?.markupdown_value > 0
      ).length > 0;
    setIsVSUniquePricingEvent(vsUniquePricingGroups);
  }, [allGroups.length]);

  const handleOV = checked => {
    const groupToEditIndex = pricingGroups.findIndex(group => group.id === focusedPricingGroup);
    const newGroups = cloneDeep(pricingGroups);
    newGroups[groupToEditIndex].exclude_obstructed_view = checked ? 1 : 0;
    newGroups[groupToEditIndex].sections = store.getState().pricing.selectedGroup.sections;
    newGroups[groupToEditIndex].sg_sections = store.getState().pricing.selectedGroup.sg_sections;
    newGroups[groupToEditIndex].tnd_sections = store.getState().pricing.selectedGroup.tnd_sections;
    pricingActions.setGroup(newGroups[groupToEditIndex]);
    setSelectedPricingGroup(newGroups[groupToEditIndex]);
    // eslint-disable-next-line react/prop-types
    props.groupsUpdateReArrange({ ...newGroups[groupToEditIndex], section: [] });
    validateChanges(newGroups[groupToEditIndex], 'exclude_obstructed_view');
  };

  const onBeforeCapture = result => {
    setIsDragging(Number(result.draggableId));
  };

  const handleOnDragEnd = result => {
    setIsDragging(0);
    if (!result.destination) {
      return;
    }
    setDisplayCustomSortingOption(true);
    setGroupSortingCriteria('custom');
    const items = Array.from(pricingGroups);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    const orderedGroups = updateGroupsPosition(items);
    reorderedItem.previousPosition = result.source.index;
    store.dispatch(setGroupsAction(orderedGroups));
    const positionObj = {};
    for (let i = 0; i < items.length; i += 1) {
      positionObj[items[i].id] = items[i].position;
    }
    setGroupsPositionObj(positionObj);
    setSortingCriteriaClicked(true);
  };

  const updatedTimes = [
    moment
      .utc(SBEventMeta?.last_updated?.autoprice)
      .local()
      .format('YYYY-MM-DD HH:mm:ss'),
  ];

  const ticketsPerGroup = group => {
    let tickets = 0;

    group.ranks.forEach(rank => {
      const groups = groupedListings.filter(gl => gl.skybox_id === rank.skybox_listing_id);
      groups.forEach(g => {
        tickets += g.quantity;
      });
    });
    return tickets;
  };

  const averageValueGroup = group => {
    let value = 0;
    let groupLength = 0;

    group.ranks.forEach(rank => {
      const groups = groupedListings.filter(gl => gl.skybox_id === rank.skybox_listing_id);
      groups.forEach(g => {
        value += g.cost.total;
        groupLength += g.quantity;
      });
    });
    return Math.round(value / groupLength);
  };

  const groupAnchorPrice = group => {
    if (group.ranks) {
      const groupAchor = getAnchorListingPrice(group);
      if (groupAchor) {
        return parseFloat(groupAchor.replace('$', ''));
      }
    }
    return 0;
  };

  const orderGroups = sortingCriteria => {
    /* eslint-disable no-nested-ternary */
    switch (sortingCriteria.toLowerCase()) {
      case 'numberoftickets':
        return pricingGroups.sort((group1, group2) =>
          ticketsPerGroup(group1) < ticketsPerGroup(group2)
            ? 1
            : ticketsPerGroup(group1) > ticketsPerGroup(group2)
            ? -1
            : ticketsPerGroup(group1) === ticketsPerGroup(group2) && group1.id < group2.id
            ? 1
            : ticketsPerGroup(group1) === ticketsPerGroup(group2) && group1.id > group2.id
            ? -1
            : 0
        );
      case 'averagecost':
        return pricingGroups.sort((group1, group2) =>
          averageValueGroup(group1) < averageValueGroup(group2)
            ? -1
            : averageValueGroup(group1) > averageValueGroup(group2)
            ? 1
            : averageValueGroup(group1) === averageValueGroup(group2) &&
              ticketsPerGroup(group1) < ticketsPerGroup(group2)
            ? 1
            : averageValueGroup(group1) === averageValueGroup(group2) &&
              ticketsPerGroup(group1) > ticketsPerGroup(group2)
            ? -1
            : averageValueGroup(group1) === averageValueGroup(group2) &&
              ticketsPerGroup(group1) === ticketsPerGroup(group2) &&
              group1.id < group2.id
            ? 1
            : averageValueGroup(group1) === averageValueGroup(group2) &&
              ticketsPerGroup(group1) === ticketsPerGroup(group2) &&
              group1.id > group2.id
            ? -1
            : 0
        );
      case 'anchorprice':
        return pricingGroups.sort((group1, group2) =>
          groupAnchorPrice(group1) < groupAnchorPrice(group2)
            ? 1
            : groupAnchorPrice(group1) > groupAnchorPrice(group2)
            ? -1
            : groupAnchorPrice(group1) === groupAnchorPrice(group2) && ticketsPerGroup(group1) < ticketsPerGroup(group2)
            ? 1
            : groupAnchorPrice(group1) === groupAnchorPrice(group2) && ticketsPerGroup(group1) > ticketsPerGroup(group2)
            ? -1
            : groupAnchorPrice(group1) === groupAnchorPrice(group2) &&
              ticketsPerGroup(group1) === ticketsPerGroup(group2) &&
              group1.id < group2.id
            ? 1
            : groupAnchorPrice(group1) === groupAnchorPrice(group2) &&
              ticketsPerGroup(group1) === ticketsPerGroup(group2) &&
              group1.id > group2.id
            ? -1
            : 0
        );
      case 'default':
        return pricingGroups.sort((group1, group2) => (group1.id < group2.id ? 1 : group1.id > group2.id ? -1 : 0));
      case 'custom':
        return pricingGroups.sort((group1, group2) =>
          group1.position < group2.position ? -1 : group1.position > group2.position ? 1 : 0
        );
      default:
        return pricingGroups;
    }
  };

  const handleGroupSortingChange = event => {
    setGroupSortingCriteria(event.target.value.toLowerCase());
    const orderedGroups = orderGroups(event.target.value);
    store.dispatch(setGroupsAction(orderedGroups));
    setSortingCriteriaClicked(true);
  };

  useEffect(() => {
    if (sortingCriteriaClicked) {
      putEventGroupsSortingCriteria({
        sorting_criteria: groupSortingCriteria,
        position: groupsPositionObj,
        eventId: skyboxId,
      });
      putGroupsPosition(getGroupsPosition(pricingGroups), skyboxId);
      setSortingCriteriaClicked(false);
      setDisplaySortingsaved(true);
      setTimeout(() => {
        setDisplaySortingsaved(false);
      }, 3000);
    }
  }, [sortingCriteriaClicked]);

  useEffect(() => {
    if (skyboxId) {
      fetchData(skyboxId);
    }
  }, [skyboxId]);

  useEffect(() => {
    if (selectedPricingGroup !== null && Object.keys(selectedPricingGroup).length > 0) {
      const newBadGroups = getBadGroupsData([selectedPricingGroup]);
      const badGroupsFiltered = badGroups.filter(group => group.id !== selectedPricingGroup.id);
      if (newBadGroups.length > 0) {
        badGroupsFiltered.push(selectedPricingGroup);
      }
      if (badGroupsFiltered) {
        store.dispatch(setBadGroups(badGroupsFiltered));
      }
    }
  }, [errorFlags]);

  useEffect(() => {
    orderGroups(groupSortingCriteria);
    if (selectedPricingGroup) {
      const currentRank = selectedPricingGroup.ranks;
      const groupInfo = pricingGroups.find(p => p.id === selectedPricingGroup.id);
      if (groupInfo && groupInfo.ranks.length !== currentRank.length) {
        setSelectedPricingGroup({
          ...selectedPricingGroup,
          marketplace: groupInfo.marketplace,
          ranks: groupInfo.ranks,
          sg_sections: groupInfo.sg_sections,
          tnd_sections: groupInfo.tnd_sections,
        });
      }
    }
  }, [pricingGroups, initialMarketPlaces.length]);

  useEffect(() => {
    if (!focusedPricingGroup) {
      setSelectedPricingGroup(null);
    }
  }, [focusedPricingGroup]);

  useEffect(() => {
    const currentGroup = selectedPricingGroup;
    if (currentGroup) {
      const compAllCurrentGroup = currentGroup.comp_all;
      currentGroup.comp_all = isCompAllGroup;
      setSelectedPricingGroup(currentGroup);
      if (!isCompAllGroup && compAllCurrentGroup !== isCompAllGroup) {
        let finalGroups = setSectionsGroup(pricingGroups, currentGroup.id, 'ticketnetwork', []);
        finalGroups = setSectionsGroup(finalGroups, currentGroup.id, 'seatgeek', []);
        store.dispatch(setGroupsAction(finalGroups));
      }
    }
  }, [isCompAllGroup]);

  if (MetaSBEvent && MetaSBEvent.sorting_criteria) {
    if (groupSortingCriteria) {
      orderGroups(groupSortingCriteria);
    } else {
      orderGroups(MetaSBEvent.sorting_criteria);
      setSBEventMeta(null);
    }
  }

  const currentComps = currTNCompSections;

  const [marketplaceTab, setMarketplaceTabChange] = useState('');

  const setMarketplaceTab = market => {
    setMarketplaceTabChange(market);
    const marketFound = MARKETPLACE_ITEMS.find(item => item.id === market);
    const value = marketFound?.value;
    pricingActions.setFocusedPricingGroupMarketplace(value);
  };

  useEffect(() => {
    if (selectedPricingGroup !== null) {
      const newGroups = pricingGroups.filter(x => x.id !== selectedPricingGroup.id);
      newGroups.push(selectedPricingGroup);
      const badGroupsData = getBadGroupsData(newGroups);
      if (badGroupsData.length > 0) {
        store.dispatch(setBadGroups(badGroupsData));
      }
    }
  }, [selectedPricingGroup, marketplaceTab]);

  const handleCeilingError = error => {
    if (error) return 'Ceiling should not be lower than Floor';

    return null;
  };

  function valueToNumber(value) {
    // Remove the dolar sign and convert the value on a float number
    if (typeof value === 'string') {
      const number = parseFloat(value.replace('$', ''));
      return number;
    }
    return value;
  }

  /**
   * Validates manual price field
   * @param {string} manualPrice
   * @param {string} floor
   * @param {string} ceiling
   * @returns {Boolean}
   * True if errors present (fails checks)
   * False if no errors with input/validation
   */
  const isManualPriceError = (manualPrice, floor, ceiling) => {
    // if manual price is type null validation is canceled
    if (manualPrice === null || manualPrice === '') return false;
    // if floor is present but ceiling is not included
    // manualPrice must be less than floor
    if (!isStringEmpty(floor) && isStringEmpty(ceiling)) {
      return Number(valueToNumber(manualPrice)) < Number(valueToNumber(floor));
    }

    // if both floor and ceiling are included
    // manualPrice must be between floor and ceiling (not-inclusive)
    if (!isStringEmpty(floor) && !isStringEmpty(ceiling)) {
      return (
        Number(valueToNumber(manualPrice)) < Number(valueToNumber(floor)) ||
        Number(valueToNumber(manualPrice)) > Number(valueToNumber(ceiling))
      );
    }

    return false;
  };

  const handleGroupAttrEdit = (field, sortedRanks = null, pIncrementSymbol = null, group = null) => (event, optVal) => {
    if (event) event.stopPropagation();
    const groupEdited = group || store.getState().pricing.selectedGroup;
    if (field === 'dynamic_pricing_enabled') {
      // eslint-disable-next-line no-param-reassign
      groupEdited.dynamic_pricing_enabled = event.target.checked;
    }

    const currentPricingGroups = group || store.getState().pricing.selectedGroup;
    let newAttrValue = sortedRanks || event?.target?.value || optVal || '';
    if (!newAttrValue && typeof event?.target?.value === 'number') {
      newAttrValue = event?.target?.value;
    }
    let floorCeilingError = false;
    let pairedFieldAlreadyFlagged = false;
    let manualPriceError = false;
    const manualPriceAlreadyFlagged = errorFlags.includes('manual_price'); // O(N)
    const prev = currentPricingGroups.splits;
    const isEmpty = newAttrValue.length < 1;

    if (field === 'pricing_strategy_comments' && newAttrValue.length > 255) {
      return;
    }

    if (field === 'increment_symbol') {
      // eslint-disable-next-line no-param-reassign
      field = 'increment';
      if (newAttrValue === '-') {
        newAttrValue = -Math.abs(groupEdited[field]);
      } else {
        newAttrValue = Math.abs(groupEdited[field]);
      }
    }
    if (pIncrementSymbol !== null && newAttrValue !== '') {
      newAttrValue = pIncrementSymbol === '-' ? -Math.abs(newAttrValue) : Math.abs(newAttrValue);
    }

    const hasError = (currField => {
      switch (currField) {
        case 'pricing_strategy_id':
          if (newAttrValue > 0) {
            groupEdited.pricing_strategy_comments = '';
            errorFlags.push('pricing_strategy_comments');
          } else {
            errorFlags.splice(errorFlags.indexOf('pricing_strategy_comments'), 1);
          }
          return false;
        case 'pricing_strategy_comments':
          if (groupEdited.pricing_strategy_id > 0 && !newAttrValue?.length)
            errorFlags.push('pricing_strategy_comments');
          else errorFlags.splice(errorFlags.indexOf('pricing_strategy_comments'), 1);
          return groupEdited.pricing_strategy_id > 0 && !newAttrValue?.length;
        case 'floor':
          if (isStringEmpty(newAttrValue)) return true;
          floorCeilingError = isStringEmpty(groupEdited.ceiling || '')
            ? false
            : Number(newAttrValue) > Number(groupEdited.ceiling);
          pairedFieldAlreadyFlagged = errorFlags.includes('ceiling'); // O(N)
          if (floorCeilingError && !pairedFieldAlreadyFlagged) {
            errorFlags.push('ceiling');
          }
          if (!floorCeilingError && pairedFieldAlreadyFlagged) {
            errorFlags.splice(errorFlags.indexOf('ceiling'), 1);
          }

          manualPriceError = isManualPriceError(groupEdited.manual_price, newAttrValue, groupEdited.ceiling || '');

          if (manualPriceError && !manualPriceAlreadyFlagged) {
            errorFlags.push('manual_price');
          }
          if (!manualPriceError && manualPriceAlreadyFlagged) {
            errorFlags.splice(errorFlags.indexOf('manual_price'), 1);
          }

          if (event.type === 'blur' && !isStringEmpty(newAttrValue)) {
            newAttrValue = formatFloat(Math.abs(newAttrValue));
          }

          return floorCeilingError;
        case 'ceiling':
          floorCeilingError =
            isStringEmpty(newAttrValue) || typeof newAttrValue === 'undefined'
              ? false
              : Number(newAttrValue) < Number(groupEdited.floor);
          pairedFieldAlreadyFlagged = errorFlags.includes('floor'); // O(N)
          if (floorCeilingError && !pairedFieldAlreadyFlagged) {
            errorFlags.push('floor');
          }
          if (!floorCeilingError && pairedFieldAlreadyFlagged) {
            errorFlags.splice(errorFlags.indexOf('floor'), 1);
          }

          manualPriceError = isManualPriceError(groupEdited.manual_price, groupEdited.floor, newAttrValue);

          if (manualPriceError && !manualPriceAlreadyFlagged) {
            errorFlags.push('manual_price');
          }
          if (!manualPriceError && manualPriceAlreadyFlagged) {
            errorFlags.splice(errorFlags.indexOf('manual_price'), 1);
          }

          if (event.type === 'blur' && !isStringEmpty(newAttrValue)) {
            newAttrValue = formatFloat(Math.abs(newAttrValue));
          }

          return floorCeilingError;
        case 'splits':
          if (isEmpty) {
            newAttrValue = prev;
            return false;
          }

          return false;
        case 'manual_price':
          if (event.type === 'blur' && !isStringEmpty(newAttrValue)) {
            newAttrValue = formatFloat(Math.abs(newAttrValue));
          }
          return isManualPriceError(newAttrValue, groupEdited.floor, groupEdited.ceiling || '');
        case 'auto_broadcast':
          if (event.type === 'blur' && !isStringEmpty(newAttrValue)) {
            newAttrValue = onlyNumbers(newAttrValue);
          }
          return false;
        case 'spaceout':
          if (isStringEmpty(newAttrValue)) {
            if (newAttrValue.length === 0) {
              errorFlags.push('spaceout');
              return true;
            }
          }
          return false;
        case 'increment':
          if (isStringEmpty(newAttrValue)) {
            if (newAttrValue.length === 0) {
              errorFlags.push('increment');
              return true;
            }
          }
          return false;
        default:
          return false;
      }
    })(field);

    const currErrorFlags = Array.from(errorFlags); // O(N)
    const alreadyFlagged = currErrorFlags.includes(field); // O(N)

    if (hasError && !alreadyFlagged) {
      currErrorFlags.push(field);
    }
    if (!hasError && alreadyFlagged) {
      currErrorFlags.splice(currErrorFlags.indexOf(field), 1); // O(N)
    }

    const isTypeField = field === 'spaceout_type' || field === 'increment_type';

    if (isTypeField && isStringEmpty(newAttrValue)) {
      newAttrValue = groupEdited[field];
    }

    if (field === 'marketplace') {
      const marketplaceInfo = MARKETPLACE_ITEMS.find(m => m.id === newAttrValue);
      const { value: marketplaceValue } = marketplaceInfo;
      newAttrValue = [marketplaceValue];
    }

    if (field === 'auto_broadcast' && newAttrValue < 0) {
      newAttrValue = null;
    }

    groupEdited[field] = newAttrValue;
    if (field === 'splits') {
      pricingActions.setSplits(newAttrValue);
    } else {
      pricingActions.setGroup(groupEdited);
    }

    setSelectedPricingGroup(groupEdited);
    // eslint-disable-next-line react/prop-types
    props.groupsUpdateReArrange({ ...groupEdited, section: [] });

    setErrorFlags(currErrorFlags);
    validateChanges(groupEdited, field);
  };

  const handleMultipleAttrEdit = changes => {
    const groupEdited = store.getState().pricing.selectedGroup;
    Object.entries(changes).forEach(([field, value]) => {
      groupEdited[field] = value;
    });
    pricingActions.setGroup(groupEdited);
    setSelectedPricingGroup(groupEdited);
    props.groupsUpdateReArrange({ ...groupEdited, section: [] });
    Object.keys(changes).forEach(field => {
      const storeState = store.getState();
      const initialGroups = storeState.refreshGroups.initialGroups || [];
      const currentGroupFields = storeState.refreshGroups.groupFields;
      const { isPushEnable } = storeState.refreshGroups;
      const initGroup = initialGroups.find(init => init.id === groupEdited.id);
      const enablePush = validateGroupChanges(initGroup, groupEdited, field);
      const { newGroupFieldsToUpdate, pushEnableUpdateValue } = saveGroupChanges(
        groupEdited.id,
        enablePush,
        isPushEnable,
        field,
        currentGroupFields,
        null,
        handleGroupCriteriaChanges
      );
      if (Object.keys(newGroupFieldsToUpdate).length > 0) {
        store.dispatch(updateGroupFields(newGroupFieldsToUpdate));
      }
      if (pushEnableUpdateValue === true || pushEnableUpdateValue === false) {
        store.dispatch(setPushEnableAction(pushEnableUpdateValue));
      }
    });
  };

  const getMarketplaces = () => {
    if (!selectedPricingGroup) return null;
    if (marketplaces && marketplaces.groups_ids) return getGroupMarkets(selectedPricingGroup.id, marketplaces);
    return marketplaces[selectedIndex];
  };

  const getErrorFlags = pricingGroup => {
    const newErrFlags = pricingGroups.map(() => []);

    let pricingFloor = pricingGroup.floor;
    if (typeof pricingFloor === 'number') {
      pricingFloor = toString(pricingFloor);
    }
    let pricingCeiling = pricingGroup.ceiling;
    if (typeof pricingCeiling === 'number') {
      pricingCeiling = toString(pricingCeiling);
    }

    if (isStringEmpty(pricingFloor || '')) {
      newErrFlags.push('floor');
    } else if (!isStringEmpty(pricingCeiling || '') && valueToNumber(pricingCeiling) < valueToNumber(pricingFloor)) {
      newErrFlags.push('floor', 'ceiling');
    }

    if (isManualPriceError(pricingGroup.manual_price, pricingGroup.floor, pricingGroup.ceiling || '')) {
      newErrFlags.push('manual_price');
    }
    setErrorFlags(newErrFlags);
  };

  const setGroupFocus = useCallback(
    (pricingGroup, groupId, event, index, view) => {
      setErrorFlags(pricingGroups.map(() => []));

      if (view === 'max') {
        focusPricingGroupSection(pricingGroup?.id)(event);
        if (pricingGroup.id === focusedPricingGroup) {
          setSelectedPricingGroup(null);
          setSelectedIndex(-1);
        } else {
          setSelectedPricingGroup(pricingGroup);
          setSelectedIndex(index);
          getErrorFlags(pricingGroup);
        }
      } else {
        focusPricingGroupSection(groupId)(event);
        setSelectedPricingGroup(pricingGroup);
        setSelectedIndex(index);
        if (pricingGroup) {
          getErrorFlags(pricingGroup);
        }
      }
    },
    [
      pricingGroups,
      focusedPricingGroup,
      setErrorFlags,
      setSelectedPricingGroup,
      setSelectedIndex,
      focusPricingGroupSection,
      getErrorFlags,
    ]
  );

  useEffect(() => {
    if (Object.keys(setFocusGroupInfo).length > 0) {
      const { pricingGroup, groupId, event, index, view } = setFocusGroupInfo;
      setGroupFocus(pricingGroup, groupId, event, index, view);
    }
  }, [setFocusGroupInfo]);

  const incrementSymbolDefault = '-';

  const [incrementSymbol, setSymbol] = useState(incrementSymbolDefault);

  const setSymbolHandler = (event, value) => {
    const newValue = value !== null ? value : incrementSymbol;
    setSymbol(newValue);
  };

  const hasDynamicFx = groups => {
    return groups.some(
      group =>
        (group.ranks && group.ranks.some(listing => listing.dynamic_fx !== null)) || group.dynamic_spaceout_enabled
    );
  };

  const isDynamicFxEvent = hasDynamicFx(allGroups);

  useEffect(() => {
    if (allGroups && selectedPricingGroup) {
      const comparisonGroup = allGroups.find(g => g.id === selectedPricingGroup.id);
      if (comparisonGroup && comparisonGroup !== selectedPricingGroup) {
        setSelectedPricingGroup(comparisonGroup);
      }
    }
  }, [[JSON.stringify(selectedPricingGroup)]]);

  const changeShowUniquePricingEvent = event => {
    if (event.target.checked === false) {
      globalActions.setShowTMRListPrice(false);
      globalActions.setShowSHListPrice(false);
      globalActions.setShowVSListPrice(false);
    }
    if (event.target.checked === true) {
      globalActions.setShowTMRListPrice(true);
      globalActions.setShowSHListPrice(true);
      globalActions.setShowVSListPrice(true);
    }
    globalActions.setShowMPListPrice(!showMPListPrice);
  };

  const changeShowTMRListPrice = event => {
    globalActions.setShowTMRListPrice(event.target.checked);
    if (event.target.checked === false && showSHListPrice === false && showVSListPrice === false) {
      globalActions.setShowMPListPrice(false);
    }
  };

  const changeShowSHListPrice = event => {
    globalActions.setShowSHListPrice(event.target.checked);
    if (event.target.checked === false && showTMRListPrice === false && showVSListPrice === false) {
      globalActions.setShowMPListPrice(false);
    }
  };

  const changeShowVSListPrice = event => {
    globalActions.setShowVSListPrice(event.target.checked);
    if (event.target.checked === false && showTMRListPrice === false && showSHListPrice === false) {
      globalActions.setShowMPListPrice(false);
    }
  };

  const sortingSavedMessage = (
    <Grid item style={{ padding: '5px 0px 0px 5px' }}>
      <Grid container direction="row" alignItems="self-end">
        <Grid item className={classes.sortingSaved}>
          <Check />
        </Grid>
        <Grid item style={{ padding: '4px 0px 0px 4px' }}>
          <Typography className={classes.sortingSaved}>Group Sorting Saved!</Typography>
        </Grid>
      </Grid>
    </Grid>
  );

  const groupsHeader = (
    <Grid container style={{ height: '49px' }}>
      <Grid item xs="1" style={{ display: 'flex', alignItems: 'center' }}>
        <Grid container direction="row" alignItems="flex-end">
          <Grid item xs="12">
            <Typography style={{ fontSize: '20px' }}>Groups</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs="11" style={{ height: '49px' }}>
        <Box display="flex" alignItems="flex-end" justifyContent="flex-end" style={{ height: '49px' }}>
          <Grid container alignItems="flex-end" direction="row" spacing={1}>
            <Grid item xs={4} md={3} lg={3} xl={4} style={{ height: '24px' }} />
            <Grid item xs={5} md={6} lg={5} xl={5} style={{ marginTop: '5px', height: '24px' }}>
              <Box display="flex" alignItems="flex-end" justifyContent="flex-end" style={{ fontSize: '16px' }}>
                <span color="#262626">Last Updated </span>
              </Box>
            </Grid>
            <Grid item xs={2} md={3} lg={3} xl={2} alignItems="center" style={{ textAlign: 'right', height: '24px' }}>
              <Box display="flex" alignItems="center" justifyContent="center">
                <span
                  className={theme.palette.type === 'light' ? classes.label : classes.labelDark}
                  style={{ fontSize: '14px' }}
                >
                  {SBEventMeta?.last_updated?.autoprice && <TimeAgo date={updatedTimes[0]} />}
                </span>
              </Box>
            </Grid>
            <Grid item xs={12} style={{ height: '25px', marginBottom: '8px' }}>
              <Grid container alignItems="flex-end" direction="row">
                <Grid item xs={2} md={2} lg={3} xl={4} />
                <Grid item xs={7} md={7} lg={5} xl={5}>
                  <Box
                    display="flex"
                    alignItems="flex-end"
                    justifyContent="flex-end"
                    style={{ fontSize: '16px', marginRight: '3px' }}
                  >
                    <span color="#262626">Current Auto Price Interval </span>
                  </Box>
                </Grid>
                <Grid item xs={2} md={2} lg={3} xl={2}>
                  <Box display="flex" alignItems="center" justifyContent="center">
                    <span
                      className={theme.palette.type === 'light' ? classes.label : classes.labelDark}
                      style={{ fontSize: '14px' }}
                    >
                      {`${SBEventMeta?.timer} min`}
                    </span>
                  </Box>
                </Grid>
                <Grid item xs={1}>
                  <Box display="flex" alignItems="center" justifyContent="center">
                    {isFetching || MetaSBEvent === null ? (
                      <></>
                    ) : (
                      <IntervalTooltip
                        rows={(intervals && intervals.response) || []}
                        selected={`${SBEventMeta?.timer}`}
                        event={MetaSBEvent}
                      >
                        <InfoOutlined style={{ color: '#7D1F8D', fontSize: 20 }} />
                      </IntervalTooltip>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
  const groupsButtons = (
    <>
      <Grid container className={classes.saveAllBtn} style={{ marginTop: '1px' }}>
        <Grid item xs={pageMD ? 9 : 6} style={{ display: 'flex', direction: 'row' }}>
          <Grid container style={{ flex: '0 0 30%' }}>
            <Grid item xs={12}>
              <InputLabel
                shrink
                htmlFor="event-marketplace-select-group"
                className={theme.palette.type === 'light' ? classes.label : classes.labelDark}
                style={{
                  color: theme.palette.type === 'dark' ? '#FFFFFFB3' : '#0000008A',
                  marginBottom: '-6px',
                  fontSize: '13px',
                }}
              >
                Sort by
              </InputLabel>
            </Grid>
            <Grid item xs={pageMD ? 12 : undefined}>
              <Select
                value={groupSortingCriteria}
                onChange={handleGroupSortingChange}
                inputProps={{
                  name: 'marketplace',
                  id: 'event-marketplace-select-group',
                }}
              >
                <MenuItem value="default">Default</MenuItem>
                {!isAbTest && <MenuItem value="averagecost">Average Cost</MenuItem>}
                <MenuItem value="anchorprice">Anchor Price</MenuItem>
                <MenuItem value="numberoftickets">Number of Tickets</MenuItem>
                <MenuItem disabled={displayCustomSortingOption === false} value="custom">
                  Custom
                </MenuItem>
              </Select>
            </Grid>
          </Grid>
          {hasMarketplaceUniquePriceAccess() &&
            (isTMRUniquePricingEvent || isSHUniquePricingEvent || isVSUniquePricingEvent) && (
              <Grid
                container
                direction="column"
                style={{ display: 'flex', marginTop: '0.1em', marginLeft: '-1em', flex: '0 0 auto' }}
              >
                <Grid container direction="row" style={{ display: 'flex', marginTop: '0.1em', flex: '0 0 auto' }}>
                  <Grid item style={{ padding: '4px 0px 0px 8px' }}>
                    <Typography>Show Unique Price Column</Typography>
                  </Grid>
                  <Grid item style={{ padding: '6px 0px 0px 8px' }}>
                    <AntSwitch
                      checked={showMPListPrice}
                      onChange={e => {
                        changeShowUniquePricingEvent(e);
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  style={{ display: 'flex', marginTop: '-0.6em', marginLeft: '-0.3em', flex: '0 0 auto' }}
                >
                  <Grid item style={{ padding: '4px 0px 0px 8px' }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      {isTMRUniquePricingEvent && (
                        <>
                          <Checkbox
                            disabled={!showMPListPrice}
                            checked={showTMRListPrice}
                            style={{ color: showTMRListPrice ? '#9C27B0' : undefined }}
                            onChange={e => {
                              changeShowTMRListPrice(e);
                            }}
                          />
                          <InputLabel data-testid="dropdown_label">TMR</InputLabel>
                        </>
                      )}
                      {isSHUniquePricingEvent && (
                        <>
                          <Checkbox
                            disabled={!showMPListPrice}
                            checked={showSHListPrice}
                            style={{ color: showSHListPrice ? '#9C27B0' : undefined }}
                            onChange={e => {
                              changeShowSHListPrice(e);
                            }}
                          />
                          <InputLabel data-testid="dropdown_label">SH</InputLabel>
                        </>
                      )}
                      {isVSUniquePricingEvent && (
                        <>
                          <Checkbox
                            disabled={!showMPListPrice}
                            checked={showVSListPrice}
                            style={{ color: showVSListPrice ? '#9C27B0' : undefined }}
                            onChange={e => {
                              changeShowVSListPrice(e);
                            }}
                          />
                          <InputLabel data-testid="dropdown_label">VS</InputLabel>
                        </>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            )}
        </Grid>
        <Grid item xs={pageMD ? 9 : 10}>
          <Grid container style={{ display: 'flex', justifyContent: 'flex-end' }} spacing={1}>
            <Grid>
              {showPushMessage && (
                <Grid
                  container
                  direction="row"
                  style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '0.5em' }}
                >
                  <Grid item className={classes.savedLabel}>
                    <Check />
                  </Grid>
                  <Grid item className={classes.savedLabel} style={{ padding: '4px 0px 0px 4px' }}>
                    <Typography>Pushed to SB!</Typography>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className={classes.saveAllBtn}>
        <Grid item xs={pageMD ? 5 : 3} style={{ display: 'flex', direction: 'row' }}>
          {displaySortingsaved ? <Grid>{sortingSavedMessage}</Grid> : <></>}
        </Grid>
      </Grid>
    </>
  );
  const groupsCardHeader = (
    <CardHeader
      className={theme.palette.type === 'light' ? classes.cardHeader : classes.cardHeaderDark}
      style={{ height: '49px' }}
      // prettier-ignore
      avatar={(
        <div className={classes.groupsLogoBackground}>
          <GroupWork className={classes.groupsLogo} />
        </div>
      )}
      title={groupsHeader}
    />
  );

  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    const currentPosition = window.pageYOffset;
    const threshold = 440;
    if (currentPosition > threshold) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isVisible]);

  return (
    <>
      <Card square className={classes.pricingSection}>
        {groupsCardHeader}
        <GroupCriteria
          currentComps={currentComps}
          errorFlags={errorFlags}
          focusedPricingGroup={focusedPricingGroup}
          groupCriteria={groupCriteria}
          groupedListings={groupedListings}
          handleCeilingError={handleCeilingError}
          handleGroupAttrEdit={handleGroupAttrEdit}
          handleMultipleAttrEdit={handleMultipleAttrEdit}
          handleGroupCriteriaChanges={handleGroupCriteriaChanges}
          handleGroupEditSubmit={handleGroupEditSubmit}
          handleGroupMarketplaceSelection={handleGroupMarketplaceSelection}
          handleMarketplaceChange={handleMarketplaceChange}
          handleOV={handleOV}
          hasCompsSelected={currentComps?.length > 0}
          isCompAllGroup={isCompAllGroup}
          isPriceAllDisabled={isPriceAllDisabled}
          isPriceAllLoading={isPriceAllLoading}
          isGroupSaveLoading={isGroupSaveLoading}
          isSaving={isSaving}
          marketplaces={getMarketplaces()}
          pricingActions={pricingActions}
          saveAllSubmit={saveAllSubmit}
          saveZoneFilters={saveZoneFilters}
          selectedIndex={selectedIndex}
          selectedPricingGroup={selectedPricingGroup}
          setSelectedIndex={setSelectedIndex}
          setSelectedPricingGroup={setSelectedPricingGroup}
          tags={tags}
          typeListing={typeListing}
          showPushMessage={showPushMessage}
          incrementSymbol={incrementSymbol}
          incrementSymbolDefault={incrementSymbolDefault}
          setSymbolHandler={setSymbolHandler}
          setSymbol={setSymbol}
          marketplaceTab={marketplaceTab}
          setMarketplaceTab={setMarketplaceTab}
          badGroups={badGroups}
          isDynamicFxEvent={isDynamicFxEvent}
        />
        <GroupCriteriaHeader
          currentComps={currentComps}
          errorFlags={errorFlags}
          focusedPricingGroup={focusedPricingGroup}
          groupCriteria={groupCriteria}
          groupedListings={groupedListings}
          handleCeilingError={handleCeilingError}
          handleGroupAttrEdit={handleGroupAttrEdit}
          handleGroupCriteriaChanges={handleGroupCriteriaChanges}
          handleGroupEditSubmit={handleGroupEditSubmit}
          handleGroupMarketplaceSelection={handleGroupMarketplaceSelection}
          handleMarketplaceChange={handleMarketplaceChange}
          handleOV={handleOV}
          hasCompsSelected={currentComps?.length > 0}
          isCompAllGroup={isCompAllGroup}
          isPriceAllDisabled={isPriceAllDisabled}
          isPriceAllLoading={isPriceAllLoading}
          isGroupSaveLoading={isGroupSaveLoading}
          isSaving={isSaving}
          marketplaces={getMarketplaces()}
          pricingActions={pricingActions}
          saveAllSubmit={saveAllSubmit}
          saveZoneFilters={saveZoneFilters}
          selectedIndex={selectedIndex}
          selectedPricingGroup={selectedPricingGroup}
          setSelectedIndex={setSelectedIndex}
          setSelectedPricingGroup={setSelectedPricingGroup}
          tags={tags}
          typeListing={typeListing}
          showPushMessage={showPushMessage}
          isVisible={isVisible}
          incrementSymbol={incrementSymbol}
          incrementSymbolDefault={incrementSymbolDefault}
          setSymbolHandler={setSymbolHandler}
          setSymbol={setSymbol}
          marketplaceTab={marketplaceTab}
          setMarketplaceTab={setMarketplaceTab}
          badGroups={badGroups}
          isDynamicFxEvent={isDynamicFxEvent}
        />
        <Divider />
        {!isLoading && !isPricingLoading && currPricingGroups.length < 1 && (
          <TitleEmptyContainer>
            <Typography>Empty</Typography>
          </TitleEmptyContainer>
        )}
        {groupsButtons}
        {isGroupContainerLoading || isLoading || isPricingLoading || loadingGroupedListings ? (
          <Grid container>
            <Grid item xs={12}>
              <TableLoader />
            </Grid>
          </Grid>
        ) : (
          <GroupElement
            allGroups={pricingGroups}
            focusedPricingGroup={focusedPricingGroup}
            getAnchorListingPrice={getAnchorListingPrice}
            groupedListings={groupedListings}
            handleOnDragEnd={handleOnDragEnd}
            isSaving={isSaving}
            isDragging={isDragging}
            onBeforeCapture={onBeforeCapture}
            tags={tags}
            errorFlags={errorFlags}
            filteredStubhubListings={filteredStubhubListings}
            isCompAllGroup={isCompAllGroup}
            settings={settings}
            setUpdateListingsOnSave={setUpdateListingsOnSave}
            typeListing={typeListing}
            isAbTest={isAbTest}
            groupsUpdateReArrange={groupsUpdateReArrange}
            handleGroupAttrEdit={handleGroupAttrEdit}
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
            averageValueGroup={averageValueGroup}
            badGroups={badGroups}
            marketplaces={getMarketplaces()}
          />
        )}
      </Card>
    </>
  );
}

Groups.propTypes = {
  currPricingGroups: PropTypes.array.isRequired,
  currTNCompSections: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  errorFlags: PropTypes.array.isRequired,
  filteredStubhubListings: PropTypes.array.isRequired,
  focusedPricingGroup: PropTypes.number,
  focusPricingGroupSection: PropTypes.func.isRequired,
  getAnchorListingPrice: PropTypes.func.isRequired,
  globalActions: PropTypes.object.isRequired,
  groupCriteria: PropTypes.object.isRequired,
  groupedListings: PropTypes.array.isRequired,
  groupSortingCriteria: PropTypes.object.isRequired,
  handleGroupCriteriaChanges: PropTypes.func.isRequired,
  handleGroupEditSubmit: PropTypes.func.isRequired,
  handleGroupMarketplaceSelection: PropTypes.func.isRequired,
  handleMarketplaceChange: PropTypes.func.isRequired,
  isAbTest: PropTypes.bool.isRequired,
  isCompAllGroup: PropTypes.bool.isRequired,
  isGroupContainerLoading: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isPricingLoading: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  marketplaces: PropTypes.array.isRequired,
  pricingActions: PropTypes.object.isRequired,
  pricingGroups: PropTypes.array.isRequired,
  saveZoneFilters: PropTypes.func.isRequired,
  SBEventMeta: PropTypes.object.isRequired,
  setErrorFlags: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  setSaving: PropTypes.func.isRequired,
  skyboxId: PropTypes.string.isRequired,
  tags: PropTypes.array.isRequired,
  typeListing: PropTypes.string.isRequired,
  setUpdateListingsOnSave: PropTypes.func.isRequired,
  setGroupSortingCriteria: PropTypes.func.isRequired,
  validateChanges: PropTypes.func.isRequired,
  loadingGroupedListings: PropTypes.bool.isRequired,
  badGroups: PropTypes.array.isRequired,
  setFocusGroupInfo: PropTypes.object.isRequired,
  initialMarketPlaces: PropTypes.array.isRequired,
  showTMRListPrice: PropTypes.bool.isRequired,
  showMPListPrice: PropTypes.bool.isRequired,
  showSHListPrice: PropTypes.bool.isRequired,
  showVSListPrice: PropTypes.bool.isRequired,
  allGroups: PropTypes.array.isRequired,
  groupsUpdateReArrange: PropTypes.func.isRequired,
};

Groups.defaultProps = {
  focusedPricingGroup: null,
};

function mapStateToProps(state) {
  return {
    focusedPricingGroup: state.pricing.ui.focusedPricingGroup,
    skyboxId: state.pricing.eventMeta.skybox_id,
    groupEditingId: state.pricing.groupEditingId,
    isAbTest: state.pricing.eventMeta.is_ab_test,
    isGroupContainerLoading: state.pricing.isGroupContainerLoading,
    filteredStubhubListings: state.pricing.stubhubListings,
    typeListing: state.pricing.focusedPricingGroupMarketplace,
    loadingGroupedListings: state.refreshGroupsInventory.loadingGroupedListings,
    setFocusGroupInfo: state.groups.setFocusGroup,
    badGroups: state.groups.badGroups,
    initialMarketPlaces: state.refreshGroups.initialMarketPlaces,
    showTMRListPrice: state.globals.showTMRListPrice,
    showMPListPrice: state.globals.showMPListPrice,
    showSHListPrice: state.globals.showSHListPrice,
    showVSListPrice: state.globals.showVSListPrice,
    allGroups: state.refreshGroups.groups,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    pricingActions: bindActionCreators(pricingActionsImport, dispatch),
    globalActions: bindActionCreators(globalActionsImport, dispatch),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Groups);
